import { render } from "./EvaluationButton.vue?vue&type=template&id=ee3fc854"
import script from "./EvaluationButton.vue?vue&type=script&lang=js"
export * from "./EvaluationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/EvaluationButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee3fc854"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee3fc854', __exports__)) {
    api.reload('ee3fc854', __exports__)
  }
  
  module.hot.accept("./EvaluationButton.vue?vue&type=template&id=ee3fc854", () => {
    api.rerender('ee3fc854', render)
  })

}


export default __exports__